module.exports = "<router-outlet></router-outlet>\n<ng4-loading-spinner> </ng4-loading-spinner>"